/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuFilterDeliveryOptions_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterDeliveryOptions_viewer">;
    readonly " $refType": "SbRespRefineMenuFilterDeliveryOptions_viewer";
};
export type SbRespRefineMenuFilterDeliveryOptions_viewer$data = SbRespRefineMenuFilterDeliveryOptions_viewer;
export type SbRespRefineMenuFilterDeliveryOptions_viewer$key = {
    readonly " $data"?: SbRespRefineMenuFilterDeliveryOptions_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuFilterDeliveryOptions_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespRefineMenuFilterDeliveryOptions_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '09e4498fa17facd46ea50d2acd0b82cb';
export default node;
